import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {LicenseManager} from 'ag-grid-enterprise/main';


// LicenseManager.setLicenseKey('Evaluation_License_Valid_Until__28_July_2018__MTUzMjczMjQwMDAwMA==724088889d778209cb3c031af9a39e88');
LicenseManager.setLicenseKey('Evaluation_License_Not_For_Production_Valid_Until29_December_2018__MTU0NjA0MTYwMDAwMA==da4235ce6b5f52a047141c95928d9455');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);




// WEBPACK FOOTER //
// ./src/main.ts